<script>
import moment from 'moment'

export default {
  name: 'TimeMixin',
  computed: {},
  methods: {
    formatBirthDay (time) {
      if (typeof time !== 'undefined' && time !== 'undefined' && time !== null) {
        const date = new Date(time)

        const selectedYear = date.getUTCFullYear()
        const selectedMonth = String(date.getUTCMonth() + 1).padStart(2, '0') // Months are 0-indexed
        const selectedDay = String(date.getUTCDate()).padStart(2, '0')

        let newTime = moment(time).format('MM/DD/YYYY')
        if (newTime !== '01/01/1970' && newTime !== 'Invalid date') {
          return selectedMonth + '/' + selectedDay + '/' + selectedYear
        } else {
          return 'N/A'
        }
      }
      return 'N/A'
    },
    formatTime (time) {
      if (typeof time !== 'undefined' && time !== 'undefined' && time !== null) {
        let newTime = moment(time).format('MM/DD/YYYY')
        if (newTime !== '01/01/1970' && newTime !== 'Invalid date') {
          return newTime
        } else {
          return 'N/A'
        }
      }
      return 'N/A'
    },
    formatAgeFromBirthday (birthDay) {
      let newTime = moment(birthDay).format('YYYY')
      if (newTime !== '01/01/1970' && newTime !== 'Invalid date') {
        let age = ''
        if (newTime) {
          age = (new Date()).getFullYear() - newTime
        }
        return age + ' yo'
      } else {
        return ''
      }
    },
    formatBirthday (time) {
      if (typeof time !== 'undefined' && time !== 'undefined' && time !== null) {
        let newTime = moment(time).format('MM/DD/YYYY')
        if (newTime !== '01/01/1970' && newTime !== 'Invalid date') {
          return newTime
        } else {
          return 'N/A'
        }
      }
      return 'N/A'
    },
  }
}
</script>
